<template>
   <div data-cy="impersonation-access-component">
      <div v-if="state.isLoading" class="flex min-h-screen items-center justify-center">
         <div class="-mt-56">
            <p class="sr-only">{{ $t("system.loading") }}</p>
            <LoadingSpinner size="lg" />
         </div>
      </div>
   </div>
</template>

<script setup lang="ts">
/* This component is used for impersonation routes */

import { useAuthStore } from "@/stores/authStore";
import { useRouter, useRoute } from "vue-router";
import { useToastKey } from "@/plugins/useToast";
import { useI18n } from "@/vue-i18n/vue-i18n";

const authStore = useAuthStore();

const useToast = inject(useToastKey);

const $router = useRouter();
const $route = useRoute();
const { t: $t } = useI18n();

const state = reactive({
   isLoading: true,
});

function onError(error) {
   const errorMessage = error || $t("validation.permission_error");
   useToast({ text: errorMessage, type: "error" });
   state.isLoading = false;

   // redirect either to home or login page
   // (the admin user might be logged into the participant site As themselves)
   if (authStore.authTokenExists) {
      $router.push({ name: "home", params: { locale: $route.params?.locale } });
   } else {
      $router.push({ name: "login", params: { locale: $route.params?.locale } });
   }
}

onMounted(async () => {
   if (!$route.params.flow_key || !$route.params.token) {
      // Theoretically route guards will mean that we never hit this scenario
      onError($t("validation.permission_error"));
   } else {
      // Try to impersonate
      authStore
         .completeAccess($route.params.token as string)
         .then((response: any) => {
            state.isLoading = false;

            // On the older client site, there was a check at this point to see if the impersonating user was an MSL
            // the data.isMSL property is returned here, but not currently used on the participant site
            if (response?.data?.status === "Access granted") {
               $router.push({ name: "flow", params: { locale: $route.params?.locale, id: $route.params.flow_key } });
            } else {
               // We should already have hit the catch block at this point, but a backup error message just in case
               throw new Error($t("validation.no_access_error"));
            }
         })
         .catch(({ error }) => {
            onError(error);
         });
   }
});
</script>
